import { WordStats } from '../../api/wordService';
import React from 'react';
import { Button } from 'primereact/button';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Badge } from 'primereact/badge';
import { Panel } from 'primereact/panel';
import './words.css';

interface Props {
  enabled: boolean;
  words: string[];
  selected: string[];
  locked: string[];
  stats: WordStats[];
  onSelect: (value: string, selected: boolean) => void;
  onToggleLock: (value: string) => void;
  onFlip: (value: string) => void;
  onDelete: (value: string) => void;
}

const WordsComponent = ({
  enabled,
  words: data,
  selected,
  locked,
  stats,
  onSelect,
  onToggleLock,
  onFlip,
  onDelete,
}: Props) => {
  const handleSelect = (event: CheckboxChangeEvent) => {
    const { value, checked } = event.target;
    onSelect(value, !!checked);
  };

  const onAllClick = () => {
    const isAllSelected = data.length === selected.length;
    const notSelected = data.filter((v) => selected.indexOf(v) === -1);

    if (isAllSelected) {
      selected.forEach((ns) => onSelect(ns, false));
    } else {
      notSelected.forEach((ns) => onSelect(ns, true));
    }
  };

  return (
    <Panel header="Words">
      <div className="flex flex-row gap-1">
        <Checkbox
          inputId="selectAll"
          checked={data.length === selected.length}
          onChange={onAllClick}
        />
        <label htmlFor="selectAll">Select all</label>
      </div>

      <div className="flex flex-column">
        {data.map((wrd, ind) => {
          const stat = stats.find((s) => s.word === wrd);
          const description = stat?.desc?.trim();
          const isLocked = locked.indexOf(wrd) !== -1;

          return (
            <div key={ind} className="flex flex-row gap-1 align-items-center">
              <Checkbox
                disabled={!enabled}
                value={wrd}
                checked={selected.indexOf(wrd) !== -1}
                onChange={handleSelect}
              />

              <Button
                icon={`pi ${isLocked ? 'pi-lock' : 'pi-lock-open'}`}
                disabled={!enabled}
                onClick={() => onToggleLock(wrd)}
                rounded
                text
                size="small"
              />

              <Button
                icon="pi pi-refresh"
                disabled={!enabled}
                onClick={() => onFlip(wrd)}
                rounded
                text
                size="small"
              />

              <span
                className={`w-8rem${description ? ' word-with-description' : ''}`}
                title={description || undefined}
              >
                {wrd}
              </span>

              <Badge value={(stat && stat.usage) || 0} />

              <Button
                icon="pi pi-trash"
                disabled={!enabled}
                onClick={() => onDelete(wrd)}
                rounded
                text
                size="small"
              />
            </div>
          );
        })}
      </div>
    </Panel>
  );
};

export default WordsComponent;
